import { FetchPaymentProviders } from "@/services/DataService";
import {
  IGlobalWarning,
  IPaymentProvider,
  IPaymentProviderBackend,
  IPaymentProviderParams,
} from "@/types/IPaymentProvider";
import authHelper from "@/helpers/authHelper";

export class APIPaymentProvidersData implements FetchPaymentProviders {
  async fetchData(
    params: IPaymentProviderParams,
  ): Promise<{ providers: IPaymentProvider[]; globalWarning: IGlobalWarning | null }> {
    try {
      const { providers, globalWarning } = await authHelper.getProviders({ amount: params.amount, lang: params.lang });
      return {
        providers: providers.map((provider: IPaymentProviderBackend): IPaymentProvider => {
          return {
            name: provider.name,
            logo: provider.logo_url,
            displayName: provider.display_name,
            toolTip: provider.tooltip,
            tooltipPrefix: provider.tooltip_prefix,
            tooltipSuffix: provider.tooltip_suffix,
            bottomMessage: provider.bottom_message,
            country: provider.country,
            order: provider.order,
            type: provider.type,
            showGrouped: provider.show_grouped,
            featureFlagStatus: provider.feature_flag_status,
            highlight: provider.highlight,
            fee: parseFloat(provider.fee),
            maxAmount: provider.max_amount != null ? parseFloat(provider.max_amount) : null,
            minAmount: provider.min_amount != null ? parseFloat(provider.min_amount) : null,
            subtitle: provider.subtitle ?? undefined,
            groupSectionTitle: provider.group_section_title || undefined,
            groupSectionSubtitle: provider.group_section_subtitle ?? undefined,
            groupDrillTitle: provider.group_drill_title || undefined,
          } as IPaymentProvider;
        }),
        globalWarning,
      };
    } catch (error: unknown) {
      console.error(`Error fetching payment providers: ${error}`);
      throw error;
    }
  }
}
